import { RefObject, useEffect, useRef } from "react";

/**
 * Tocar una cita lleva al mensaje original y lo resalta, como WhatsApp (Esteban, 2026-10-12). Si todavía no está cargado,
 * pide los anteriores (hasta 20 tandas) y lo busca otra vez cuando llegan. `attr`: el data-atributo de cada mensaje.
 */
export const useSaltoACita = (caja: RefObject<HTMLElement>, attr: string, items: unknown, hayMas: boolean, cargarMas: () => void) => {
	const buscando = useRef<{ id: number; vueltas: number } | null>(null);
	const ir = (id: number): boolean => {
		const el = caja.current?.querySelector<HTMLElement>(`[${attr}="${id}"]`);
		if (!el) return false;
		el.scrollIntoView({ block: "center", behavior: "smooth" });
		el.classList.remove("resaltado");
		void el.offsetWidth;
		el.classList.add("resaltado");
		window.setTimeout(() => el.classList.remove("resaltado"), 1800);
		return true;
	};
	useEffect(() => {
		const b = buscando.current;
		if (!b) return;
		// Después de que se pintaron los anteriores (y de que la lista acomodó su scroll).
		const t = window.setTimeout(() => {
			if (ir(b.id)) { buscando.current = null; return; }
			if (hayMas && b.vueltas < 20) { b.vueltas += 1; cargarMas(); } else buscando.current = null;
		}, 60);
		return () => window.clearTimeout(t);
	}, [items]);
	return (id?: number | null) => {
		if (!id) return;
		if (ir(id)) { buscando.current = null; return; }
		if (hayMas) { buscando.current = { id, vueltas: 0 }; cargarMas(); }
	};
};
